import React, { useEffect, useState } from "react";

import NavBar from "../NavBar/NavBar";
import { FaAngleLeft } from "react-icons/fa";
import addRole from "../../images/icons/addRole.png";
import billing from "../../images/icons/billing.png";
import Delete from "../../images/icons/delete.png";
import Rectangle from "../../images/Rectangle.png";

import UserWallbox from "./WallboxSingle/UserWallbox";
import AllActivities from "./WallboxSingle/AllActivities";

import { Link } from "react-router-dom";
import { AiOutlineSearch } from "react-icons/ai";
import { IoMdKey } from "react-icons/io";
import { useParams } from "react-router-dom";
import axios from "axios";
import { TailSpin } from "react-loader-spinner";


const WallboxSingle = () => {
  document.title = "Wallbox - POWERGrid Cloud"

  const [wallBox, setWallbox] = useState({})

  const params = useParams()
  const { wallboxId } = params

  useEffect(() => {
    if (wallboxId) {
      axios.get(`http://116.203.191.150:5013/api/wallbox_info/${wallboxId}`, {
        headers: {
          authorization: "Bearer PuUf.9\\fMR~LkLE_=bF*_,r9niN&$Z"
        }
      })
        .then(response => {
          if (response.data) {
            setWallbox(response.data)
          }
        })
        .catch(error => {
          console.error("Got Error", error)
        })
    }
  }, [wallboxId])

  const { wallbox } = wallBox

  let theDate;
  if (wallbox) {
    theDate = new Date(wallbox?.created_at).toLocaleDateString()
  }

  console.log(wallBox)

  return (
    <>
      <NavBar />
      <main className="wrapper">
        <div className="page-content">
          <div className="wallbox-area">
            <div className="pages-title-list">
              <ul>
                <li>
                  <Link to="/">All Wallbox</Link>
                </li>
                <li>
                  <span>{wallboxId}</span>
                </li>
              </ul>
            </div>

            <div className="wallbox_single_content">
              <div className="single_all_list">
                <ul className="box_progress">
                  <li>
                    <Link to="/">
                      <FaAngleLeft /> All Wallbox
                    </Link>
                  </li>
                  <li>
                    <span>Wallbox Functions</span>
                  </li>
                  <li>
                    <Link to="">
                      <img alt="" src={addRole} /> Add Role to User
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      <img alt="" src={billing} /> Billing Details
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      <img alt="" src={Delete} /> Delete Wallbox
                    </Link>
                  </li>
                </ul>
                <ul className="box_progress">
                  <li>Wallbox Progress</li>
                </ul>
              </div>
              <div className="details_cont">
                <div className="wallbox_details" style={{ position: "relative" }}>
                  <div className="h5">Wallbox Details</div>
                  {
                    wallbox ?
                      <div className="wallbox_details_content">
                        <form action="">
                          <div className="box_group">
                            <label>Product Type</label>
                            <input type="text" defaultValue={wallbox?.product_type} readOnly />
                          </div>
                          <div className="box_group">
                            <label><IoMdKey /> Environment Key (Wallbox Serial) </label>
                            <input type="text" defaultValue={wallbox?.serial_number} readOnly />
                          </div>
                          <div className="box_group">
                            <label>Firmware Version</label>
                            <input type="text" defaultValue={wallbox?.firmware_ist} readOnly />
                          </div>
                          <div className="box_group">
                            <label>Date installed</label>
                            <input type="text" defaultValue={theDate} readOnly />
                          </div>
                          <div className="box_group">
                            <label>Owner</label>
                            <input type="text" defaultValue={wallbox?.owner} readOnly />
                          </div>
                          <div className="box_group">
                            <label>Installed Adresse</label>
                            <input
                              type="text"
                              defaultValue={wallbox?.installed_address}
                              readOnly
                            />
                          </div>
                          <div className="box_group">
                            <label>Company Name</label>
                            <input type="text" defaultValue={wallbox?.company} readOnly />
                          </div>
                        </form>
                        <div className="box_right_img">
                          <img alt="" src={Rectangle} />
                          <span>Status</span>
                          <span className="Running">Running</span>
                        </div>
                      </div>
                      :
                      <div className="router-loading-spinner">
                        <TailSpin width={25} height={25} color="#002060" />
                      </div>
                  }
                </div>
                <div className="user_wallbox">
                  <div className="h5">User in Wallbox</div>
                  <form action="">
                    <input type="input" placeholder="Search Product..." />
                    <button type="submit">
                      <AiOutlineSearch />
                    </button>
                  </form>
                  <UserWallbox />
                </div>
              </div>
              <div className="allActivities">
                <AllActivities />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default WallboxSingle;
